module.exports = __webpack_public_path__ + "static/media/CultureBeat_Vector_Logo.c1287881.svg";